import ManagePhenologicalStateTable from './ManagePhenologicalStateTable'

const ManagePhenologicalState = {
  Table: ManagePhenologicalStateTable,
}

export default ManagePhenologicalState
